import { render, staticRenderFns } from "./shiftManagementAssignment.vue?vue&type=template&id=18528550&scoped=true"
import script from "./shiftManagementAssignment.vue?vue&type=script&lang=js"
export * from "./shiftManagementAssignment.vue?vue&type=script&lang=js"
import style0 from "./shiftManagementAssignment.vue?vue&type=style&index=0&id=18528550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18528550",
  null
  
)

export default component.exports